import React from 'react'
import { Row, Col, Button, notification, Tabs } from 'antd'
import { useDebounce} from 'usehooks-ts'

import API from '../../services/API'
import Segment from '../../components/Segment'
import PanelRelations from './PanelRelations'
import PanelGeneralData from './PanelGeneralData'
import PanelImages from './PanelImages'
import PanelPrices from './PanelPrices'

const { TabPane } = Tabs

const INIT = {
    name: '',
    description: '',
    active: true,
    sat_code: '',
    slug: '',
    barcode: '',
    min_supply: '',
    sku: '',
    in_stock: null,
    cost: 0,
    base_price: 0,
    ///Prices
    franquicia: 0, //1.10
    mayoreo: 0, // 1.25
    mediomayoreo: 0, //1.35
    //relationships
    brand_id: null,
    product_type_id: null,
    currency_id: null,
    measure_unit_id: null,
    tax_type_id: 0,
    tax_type_second_id: 0,
    cost_without_freight: 0,
    freight: 0,
    general: 0, // 1.80
    customer_types:[],
    disabled: false,
    sat_code_item:null,
    sat_unit_code: '',
    sat_unit_code_item: null,
    sat_unit_code_id: null
}

const ProductsCreateContainer = props => {
    const { user } = props
    const [data, setData] = React.useState(INIT)
    const [prices, setPrices] = React.useState([])
    const [images, setImages] = React.useState([])
    const [currentDataProductDesc, setCurrentDataProductDesc] = React.useState([])
    const [currentDataProductAsc, setCurrentDataProductAsc] = React.useState([])
    const [loading, setloading] = React.useState(false)
    const debouncedSatCode= useDebounce(data.sat_code,800);
    const debouncedSatUnitCode = useDebounce(data.sat_unit_code, 800);

    const getSubsidiaries = () => {
        API.get('/api/subsidiaries?pagination=false&filter[active]=1&sort=logo_url')
            .then(response => {
                //setSubsidiaries(response.data)
                if (response.data) {
                    setPrices(
                        response.data.map(item => {
                            return {
                                id: null,
                                product_id: null,
                                price: 0,
                                tax1: 0,
                                tax2: 0,
                                subsidiary_id: item.id,
                                subsidiary: item,
                                available_for_sale: true,
                                created_by: user.id,
                                taxAmount1: 0,
                                taxAmount2: 0,
                            }
                        })
                    )
                }
            })
            .catch(error => {
                console.error(error)
            })
    }
    React.useEffect(() => {
        customer_types();
        getSubsidiaries()
    }, [])
    React.useEffect(() => {
   console.log('data',data)
    },[data])

    React.useEffect(() => {
        if(data.sat_code && data.sat_code !== '' && data.sat_code.length >= 6 && data.sat_code.length <= 8){
            getDescriptionSat(data.sat_code);
         }
    }, [debouncedSatCode]);

    React.useEffect(() => {
        if (data.sat_unit_code && data.sat_unit_code.length >= 2) {
            getSatUnitCode(data.sat_unit_code);
        }
    }, [debouncedSatUnitCode]);

    // const handleChange = (name, value) => {
    //     const newData = { ...data }
    //     newData[name] = value
    //     setData(newData)
    // }
    //Persitencia al modifcar dos inputs al mismo tiempo
    const handleChange = (name, value) => {
        setData(prevData => {
            const newData = { ...prevData };
            newData[name] = value;
            return newData;
        });
    }

    const handleSubmit = () => {
        setloading(true)
        if (!data.brand_id ) {
            notification.error({
                message: 'La marca es requerida',
            })
            setloading(false)
            return
        }
        const newData = {
            ...data,
            prices: prices,
            productsAsc: currentDataProductAsc,
            productsDesc: currentDataProductDesc,
        }

        API.post('/api/products', newData)
            .then(response => {
                setloading(false)
                if (response.data) {
                    handleSaveImages(response.data.id)
                    setData(INIT)
                    notification.success({
                        message: 'El producto se ha creado exitosamente',
                    })
                }
            })
            .catch(error => {
                setloading(false)
                if (error.response && error.response.data && error.response.data.message) {
                    notification.error({
                        message: error.response.data.message[0],
                    })
                }
            })
    }

    const handleSaveImages = async id => {
        const toUpload = images.filter(img => !img.markedForDeletion && !Number.isInteger(img.uid))
        const toDelete = images.filter(img => img.markedForDeletion && Number.isInteger(img.uid))
        const mainCandidate = images.find(img => !img.markedForDeletion && img.isMain)

        setloading(true)
        try {
            const uploaded = await Promise.all(
                toUpload.map(image => {
                    const formData = new FormData()
                    formData.append('image', image.originFileObj)
                    return API.post(`/api/products/${id}/images`, formData)
                        .then(response => ({ localUid: image.uid, id: response.data.id }))
                })
            )

            if (mainCandidate) {
                const mainId = Number.isInteger(mainCandidate.uid)
                    ? mainCandidate.uid
                    : (uploaded.find(u => u.localUid === mainCandidate.uid) || {}).id

                if (mainId) {
                    await API.patch(`/api/products/images/${mainId}/main`)
                }
            }

            await Promise.all(toDelete.map(image => API.delete(`/api/products/images/${image.uid}`)))
        } catch (error) {
            notification.error({
                message: 'Ha ocurrido un error al guardar las imágenes',
            })
        } finally {
            setloading(false)
        }
    }
    const getDescriptionSat = (sat_code) => {
        setloading(true)
        API.get(`/api/sat_code?filter[code]=${sat_code}&pagination=false&first=true`)
            .then(response => {
                setloading(false)
                if (response.data) {
                    handleChange("sat_code_item", response.data);
                  }
            })
            .catch(error => {
                setloading(false)
                notification.error({ message: error.message })
            })
    }

    const getSatUnitCode = (key) => {
        setloading(true)
        API.get(`/api/sat_unit_code?filter[key]=${key}&pagination=false&first=true`)
            .then(response => {
                setloading(false)
                if (response.data) {
                    handleChange('sat_unit_code_item', response.data);
                    handleChange('sat_unit_code_id', response.data.id);
                }
            })
            .catch(error => {
                setloading(false)
                notification.error({ message: error.message })
            })
    }


    const customer_types= () => { //Mostramos los porcentajes que se encuentran en la base de datos catalogo customer_types
        setloading(true)
        API.get(`/api/customer_types?pagination=false&filter[active]=1`)
            .then(response => {
                setloading(false)
                if (response.data) {
                    //TODO: corregir el consecutivo de los ID's, Modificar por el codigo de tipo de precio que sea unique en la base de datos
                    const idToFieldMapping = {
                      1: "general",
                      4: "franquicia",
                      5: "mediomayoreo",
                      6: "mayoreo",
                      8: "franquicia2",
                      9: "franquicia3",
                    };
                    const newData = { ...data };
                    response.data.forEach(element => {
                      const fieldName = idToFieldMapping[element.id];
                      if (fieldName) {
                        newData[fieldName] = element.percent_value;
                      }
                    });
                    handleChange("customer_types", response.data);
                    setData(newData);
                  }
            })
            .catch(error => {
                setloading(false)
                notification.error({ message: error.message })
            })
    }


    return (
        <Segment loading={loading}>
            <Tabs defaultActiveKey="1">
                <TabPane tab="Información general" key="1">
                    <PanelGeneralData data={data} change={handleChange} />
                </TabPane>
                <TabPane tab="Relaciones" key="2">
                    <PanelRelations
                        desc={currentDataProductDesc}
                        setDesc={setCurrentDataProductDesc}
                        asc={currentDataProductAsc}
                        setAsc={setCurrentDataProductAsc}
                        data={data}
                    />
                </TabPane>

                <TabPane tab="Ajuste de precios" key="3">
                    <PanelPrices
                        product={data}
                        change={handleChange}
                        prices={prices}
                        setPrices={setPrices}
                    />
                </TabPane>
                <TabPane tab="Imágenes (opcional)" key="4">
                    <PanelImages images={images} setImages={setImages} />
                </TabPane>
            </Tabs>

            <br />
            <Row type="flex" justify="center">
                <Col>
                    <Button type="primary" size="large" icon="save" disabled={!data.name || !data.cost || !data.base_price || data.disabled } onClick={handleSubmit}>
                        Guardar
                    </Button>
                </Col>
            </Row>
        </Segment>
    )
}

export default ProductsCreateContainer
